import auth from "../../middlewares/auth";

export const ticketRoutes = [
    {
        // path: '/tickets/:contact_id?/:company_id?',
        path: '/tickets',
        component: () => import(/* webpackChunkName: "tickets" */ '../../views/tickets/Ticket'),
        name: 'tickets',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['ticket-manage']
        }
    },
    {
        path: '/ticket/:id/edit',
        component: () => import(/* webpackChunkName: "tickets" */ '../../views/tickets/TicketForm'),
        name: 'update-ticket',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['ticket-manage']
        }
    },
    {
        path: '/create-ticket',
        component: () => import(/* webpackChunkName: "tickets" */ '../../views/tickets/TicketForm'),
        name: 'create-ticket',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['ticket-manage']
        }
    },
    {
        path: '/ticket/:ticket_number',
        component: () => import(/* webpackChunkName: "tickets" */ '../../views/tickets/ViewTicket'),
        name: 'view-ticket',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['ticket-manage']
        }
    },
    {
        path: '/ticket-import',
        component: () => import(/* webpackChunkName: "tickets" */ '../../views/tickets/TicketImport.vue'),
        name: 'ticket-import',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['ticket-manage']
        }
    },
]